export const sortingOptions = {
    Date: "Date",
    All: "Alles",
    Active: "Actief",
    Paused: "Gepauzeerd",
    Concept: "Concept",
}

export const SessionStorageKeys = {
    last_visited_vacancy: "last_visited_vacancy",
    last_visited_feed_vacancy: "last_visited_feed_vacancy",
    reset_password_link_expired: "reset_password_link_expired",
    active_tab: "activeTab",
    has_animation_completed: "hasAnimationCompleted",
    is_application_status_visible: "isApplicationStatusVisible"
}

export const FILTER_BUTTON_OPTIONS = {
    OPEN_POSITIONS: [sortingOptions.All, sortingOptions.Active, sortingOptions.Paused, sortingOptions.Concept],
};

export const VACANCY_FILTER_STATUS = {
    [sortingOptions.All]: ["open", "filled", "concept"],
    [sortingOptions.Active]: ["open"],
    [sortingOptions.Paused]: ["filled"],
    [sortingOptions.Concept]: ["concept"],
};

export const application = {
    hi5: "application-hi5"
}

export const ApplicationRoutes = {
    hi5Root: "/company",
    hi5Settings: "/company/settings",
    hi5Vacatures: "/company/vacatures",
    hi5VacatureNew: "/company/vacatures/nieuw",
    hi5VacatureConcept: (id) => `/company/vacatures/nieuw?id=${id}`,
    hi5VacatureDetail: (id) => `/company/vacatures/${id}`,
    hi5VacatureKandidaat: (id, candidateId) => `/company/vacatures/${id}/kandidaten/${candidateId}`,
    hi5Apply: (uuid) => `/apply/${uuid}`,
    forgotPassword: "/forgot-password",
    companySignUp: "/company/sign-up"
}

export const signUpFormSteps = {
    personal_information: "personal_information",
    login_information: "login_information"
}

export const BREAKPOINTS = {
    DESKTOP: "(min-width: 1000px)"
}

export const NOT_CLASSIFIED_DEVICE_MESSAGE = "Not classified";

export const SUPPORTED_LOCALES = ['en', 'nl'];

export const DEFAULT_BRAND_COLOR = "#4598B1";

export const DEFAULT_BACKGROUND_FOCUS = 50;
